import createIcon from '../../createIcon';

/**
 * @component @name Whatshot
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMuNSAxLjMzNTk0QzEzLjUgMS4zMzU5NCAxNC4yNCAzLjk4NTk0IDE0LjI0IDYuMTM1OTRDMTQuMjQgOC4xOTU5NCAxMi44OSA5Ljg2NTk0IDEwLjgzIDkuODY1OTRDOC43NiA5Ljg2NTk0IDcuMiA4LjE5NTk0IDcuMiA2LjEzNTk0TDcuMjMgNS43NzU5NEM1LjIxIDguMTc1OTQgNCAxMS4yODU5IDQgMTQuNjY1OUM0IDE5LjA4NTkgNy41OCAyMi42NjU5IDEyIDIyLjY2NTlDMTYuNDIgMjIuNjY1OSAyMCAxOS4wODU5IDIwIDE0LjY2NTlDMjAgOS4yNzU5NCAxNy40MSA0LjQ2NTk0IDEzLjUgMS4zMzU5NFpNMTEuNzEgMTkuNjY1OUM5LjkzIDE5LjY2NTkgOC40OSAxOC4yNjU5IDguNDkgMTYuNTI1OUM4LjQ5IDE0LjkwNTkgOS41NCAxMy43NjU5IDExLjMgMTMuNDA1OUMxMy4wNyAxMy4wNDU5IDE0LjkgMTIuMTk1OSAxNS45MiAxMC44MjU5QzE2LjMxIDEyLjExNTkgMTYuNTEgMTMuNDc1OSAxNi41MSAxNC44NjU5QzE2LjUxIDE3LjUxNTkgMTQuMzYgMTkuNjY1OSAxMS43MSAxOS42NjU5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Whatshot = createIcon('Whatshot', [
  [
    'path',
    {
      d: 'M13.5 1.33594C13.5 1.33594 14.24 3.98594 14.24 6.13594C14.24 8.19594 12.89 9.86594 10.83 9.86594C8.76 9.86594 7.2 8.19594 7.2 6.13594L7.23 5.77594C5.21 8.17594 4 11.2859 4 14.6659C4 19.0859 7.58 22.6659 12 22.6659C16.42 22.6659 20 19.0859 20 14.6659C20 9.27594 17.41 4.46594 13.5 1.33594ZM11.71 19.6659C9.93 19.6659 8.49 18.2659 8.49 16.5259C8.49 14.9059 9.54 13.7659 11.3 13.4059C13.07 13.0459 14.9 12.1959 15.92 10.8259C16.31 12.1159 16.51 13.4759 16.51 14.8659C16.51 17.5159 14.36 19.6659 11.71 19.6659Z',
      key: 'b5jrml',
    },
  ],
]);

export default Whatshot;
